/* eslint-disable */
import { fabric } from 'fabric-with-gestures';
import flatten from 'lodash.flatten';
import chunk from 'lodash.chunk';

import { defaultFontValue } from '../resources/scribedefaults';
import { SCRIBE_TEXT_LINE_HEIGHT } from '../../config/defaults.js';

const findStartPoint = (pixels, lineHeight, leading, isTextRTL) => {
  leading /= 2;

  const safePercentage = 0.9;
  const safeLineHeight = Math.ceil((lineHeight + leading) * safePercentage);

  return flatten(
    chunk([...pixels], safeLineHeight).map((line, index) => {
      const coords = [];
      for (let i = 0; i < line.length; i++) {
        for (let j = 0; j < line[i].length; j++) {
          if (line[i][j] === 1) {
            coords.push({ x: j, y: i + index * safeLineHeight });
          }
        }
      }

      const sortedLine = flatten(coords)
        .filter(Boolean)
        .sort((a, b) => a.x - b.x);
      return isTextRTL ? sortedLine.reverse()[0] : sortedLine[0];
    })
  ).filter(Boolean)[0];
};

const traceFromPoint = (point, pixels, isTextRTL) => {
  let foundPoint = point;
  let pixelsArr = pixels;
  const orderedPoints = [point];
  while (foundPoint) {
    [foundPoint, pixelsArr] = findNearPoint(foundPoint, pixelsArr, isTextRTL);
    if (foundPoint) {
      orderedPoints.push(foundPoint);
    }
  }

  return [orderedPoints, pixelsArr];
};

const findNearPoint = ({ x, y }, pixels) => {
  const directions = {
    N: { y: y - 1, x },
    NW: { y: y - 1, x: x - 1 },
    W: { y, x: x - 1 },
    SW: { y: y + 1, x: x - 1 },
    S: { y: y + 1, x },
    SE: { y: y + 1, x: x + 1 },
    E: { y, x: x + 1 },
    NE: { y: y - 1, x: x + 1 }
  };

  const firstMatch = Object.values(directions).filter(direction => {
    return pixels[direction.y] && pixels[direction.y][direction.x] == 1 && direction;
  })[0];

  if (firstMatch) {
    pixels[firstMatch.y][firstMatch.x] = 0;
  }

  return [firstMatch, pixels];
};

export const generateMaskPath = (pixels, lineHeight, leading, isTextRTL) => {
  let pixelsArr = pixels;
  let startPoint = findStartPoint(pixelsArr, lineHeight, leading, isTextRTL) || {
    x: 0,
    y: 0
  };

  pixelsArr[startPoint.y][startPoint.x] = 0;
  let points = [];
  let orderedPoints = [];

  while (startPoint) {
    [orderedPoints, pixelsArr] = traceFromPoint(startPoint, pixelsArr);
    points = [...points, orderedPoints];
    startPoint = findStartPoint(pixelsArr, lineHeight, leading, isTextRTL);
    if (startPoint) {
      pixelsArr[startPoint.y][startPoint.x] = 0;
    }
  }
  return points;
};

export const getTextDimensions = element => {
  const obj = new fabric.Text(element.text, {
    fontFamily: `${element.font.value}, '${defaultFontValue}'`,
    fill: element.fill,
    fontSize: element.fontSize,
    lineHeight: SCRIBE_TEXT_LINE_HEIGHT,
    fontStyle: element.fontStyle,
    fontWeight: element.fontWeight,
    textAlign: element.align,
    snapAngle: 1
  });

  return { height: obj.height, width: obj.width };
};
